import { render } from "./Report.vue?vue&type=template&id=5b1c0d3d&scoped=true"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"

import "./Report.vue?vue&type=style&index=0&id=5b1c0d3d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b1c0d3d"

export default script